import remarkGfm from 'remark-gfm';
import { Component, Input } from '@angular/core';
import { RemarkModule } from 'ngx-remark';
import { unified } from 'unified';
import remarkParse from 'remark-parse';
import { Highlight } from 'ngx-highlightjs';

@Component({
  selector: 'app-docs-renderer',
  standalone: true,
  imports: [RemarkModule, Highlight],
  styleUrls: ['./docs-renderer.component.scss'],
  templateUrl: 'docs-renderer.component.html'
})
export class DocsRendererComponent {
  @Input() markdown: string = '';

  processor = unified().use(remarkParse).use(remarkGfm);
}
